import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

/**
 * Fires Meta Pixel PageView on SPA route changes.
 * Skips /admin and /auth routes (matches GA/GTM gating).
 */
export const MetaPixelRouteTracker = () => {
  const location = useLocation();
  const isFirstRender = useEffect as typeof useEffect;
  // Use a ref-like via module scope guard
  useEffect(() => {
    if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/auth")) {
      return;
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname, location.search]);

  return null;
};
